var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"white-space":"normal !important"},domProps:{"innerHTML":_vm._s(_vm.resolvedVbzNr)}})}
var staticRenderFns = []

export { render, staticRenderFns }